export const errorMap: { [code: number]: string } = {
  404: 'common:pageNotFound.headline',
  401: 'common:pageNotFound.accessDenied',
  406: 'common:orgUnitNegselTooltip',
};
